import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const Activate = () =>
{
    const [status, setStatus] = useState(null);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() =>
    {

        const activationCode = searchParams.get('code');
        const email = searchParams.get('email');
        if (activationCode)
        {
            axios.post(`${API_BASE_URL}/api/RegisterHomeUser/verify-activation`, { activationCode, email })
                .then(response =>
                {
                    setStatus('Activation successful!');
                    setTimeout(() => navigate('/success'), 2000);
                })
                .catch(error =>
                {
                    setStatus('Activation failed. Invalid code.');
                });
        } else
        {
            setStatus('No activation code provided.');
        }
    }, [searchParams, navigate]);

    return (
        <div>
            <h1>Account Activation</h1>
            {status ? <p>{status}</p> : <p>Activating your account...</p>}
        </div>
    );
};

export default Activate;
